var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgNavTrash = function SvgNavTrash(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5 7v15c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7H5z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20 5h-4V3c0-.6-.4-1-1-1h-4c-.6 0-1 .4-1 1v2H5c-.6 0-1 .4-1 1s.4 1 1 1h15c.6 0 1-.4 1-1s-.4-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 10v8c0 .6.4 1 1 1s1-.4 1-1v-8c0-.6-.4-1-1-1s-1 .4-1 1zm6 0v8c0 .6.4 1 1 1s1-.4 1-1v-8c0-.6-.4-1-1-1s-1 .4-1 1z",
    opacity: 0.7
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNavTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/nav-trash.e7d4e487.svg";
export { ForwardRef as ReactComponent };